import useAxios from 'hooks/useAxios';

export const getNHMetrics = async (limit = 20, page = 1, filters = {}) => {
  const api = useAxios();
  const params = {
    limit: limit,
    page: page
  };

  // Add filter parameters if provided
  if (filters?.transactionType) {
    params['filter.transactionType'] = filters.transactionType;
  }
  if (filters?.direction) {
    params['filter.direction'] = filters.direction;
  }
  if (filters?.status) {
    params['filter.status'] = filters.status;
  }
  if (filters?.engineId) {
    params['filter.engineId'] = filters.engineId;
  }
  if (filters?.roomId) {
    params['filter.roomId'] = filters.roomId;
  }
  if (filters?.betLimitId) {
    params['filter.betLimitId'] = filters.betLimitId;
  }
  if (filters?.coin) {
    params['filter.coin'] = filters.coin;
  }
  if (filters?.search) {
    params.search = filters.search;
  }

  try {
    const response = await api.get('/nh-metrics', { params });
    return {
      data: response.data.data.map((x) => ({
        ...x,
        createdAt: formatDateToLocal(x.createdAt),
        updatedAt: formatDateToLocal(x.updatedAt)
      })),
      meta: response.data.meta
    };
  } catch (err) {
    console.error('Error fetching NH metrics:', err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getNHMetricsByBetLimit = async (betLimitId, limit = 20, page = 1) => {
  const api = useAxios();
  const params = {
    limit: limit,
    page: page,
    'filter.betLimitId': betLimitId
  };

  try {
    const response = await api.get('/nh-metrics', { params });
    return {
      data: response.data.data.map((x) => ({
        ...x,
        createdAt: formatDateToLocal(x.createdAt),
        updatedAt: formatDateToLocal(x.updatedAt)
      })),
      meta: response.data.meta
    };
  } catch (err) {
    console.error('Error fetching NH metrics by bet limit:', err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getNHMetricsByEngine = async (engineId, limit = 20, page = 1) => {
  const api = useAxios();
  const params = {
    limit: limit,
    page: page,
    'filter.engineId': engineId
  };

  try {
    const response = await api.get('/nh-metrics', { params });
    return {
      data: response.data.data.map((x) => ({
        ...x,
        createdAt: formatDateToLocal(x.createdAt),
        updatedAt: formatDateToLocal(x.updatedAt)
      })),
      meta: response.data.meta
    };
  } catch (err) {
    console.error('Error fetching NH metrics by engine:', err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getNHMetricsByRoom = async (roomId, limit = 20, page = 1) => {
  const api = useAxios();
  const params = {
    limit: limit,
    page: page,
    'filter.roomId': roomId
  };

  try {
    const response = await api.get('/nh-metrics', { params });
    return {
      data: response.data.data.map((x) => ({
        ...x,
        createdAt: formatDateToLocal(x.createdAt),
        updatedAt: formatDateToLocal(x.updatedAt)
      })),
      meta: response.data.meta
    };
  } catch (err) {
    console.error('Error fetching NH metrics by room:', err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const formatDateToLocal = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short'
  }).format(date);
};
